export const supportedLanguages = ['en', 'fr', 'es'];

export default {
  supportedLanguages,
};;
